"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyProjectPermissionsFailure = exports.copyProjectPermissionsSuccess = exports.copyProjectPermissions = exports.removeUser = exports.selectUser = exports.fetchUserSuccess = exports.fetchUserFailed = exports.fetchUserRequest = exports.toggleSelect = exports.setSearchString = exports.setFilterOptions = exports.setOrderByOptions = exports.clear = exports.fetchProjectsFailed = exports.fetchProjectSuccess = exports.fetchProjectsRequests = void 0;
const ActionTypes = require("../../actionTypes/user/projects");
const fetchProjectsRequests = (user) => ({
    type: ActionTypes.FETCH_PROJECTS_REQUEST,
    payload: user
});
exports.fetchProjectsRequests = fetchProjectsRequests;
const fetchProjectSuccess = (items) => ({
    type: ActionTypes.FETCH_PROJECTS_SUCCESS,
    payload: items
});
exports.fetchProjectSuccess = fetchProjectSuccess;
const fetchProjectsFailed = (error) => ({
    type: ActionTypes.FETCH_PROJECTS_FAILED,
    payload: error
});
exports.fetchProjectsFailed = fetchProjectsFailed;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
const setOrderByOptions = (orderBy, order) => ({
    type: ActionTypes.SET_ORDER_BY_OPTIONS,
    payload: {
        orderBy,
        order
    }
});
exports.setOrderByOptions = setOrderByOptions;
const setFilterOptions = (filter, value) => ({
    type: ActionTypes.SET_FILTER_OPTIONS,
    payload: {
        filter,
        value
    }
});
exports.setFilterOptions = setFilterOptions;
const setSearchString = (searchString) => ({
    type: ActionTypes.SET_SEARCH_STRING,
    payload: {
        searchString
    }
});
exports.setSearchString = setSearchString;
const toggleSelect = (ids) => ({
    type: ActionTypes.TOGGLE_SELECT,
    payload: {
        ids
    }
});
exports.toggleSelect = toggleSelect;
const fetchUserRequest = (email) => ({
    type: ActionTypes.FETCH_USER_REQUEST,
    payload: {
        email
    }
});
exports.fetchUserRequest = fetchUserRequest;
const fetchUserFailed = (error) => ({
    type: ActionTypes.FETCH_USER_FAILED,
    error
});
exports.fetchUserFailed = fetchUserFailed;
const fetchUserSuccess = (users) => ({
    type: ActionTypes.FETCH_USER_SUCCESS,
    payload: {
        users
    }
});
exports.fetchUserSuccess = fetchUserSuccess;
const selectUser = (user) => ({
    type: ActionTypes.SELECT_USER,
    payload: {
        user
    }
});
exports.selectUser = selectUser;
const removeUser = (user) => ({
    type: ActionTypes.REMOVE_USER,
    payload: {
        user
    }
});
exports.removeUser = removeUser;
const copyProjectPermissions = () => ({
    type: ActionTypes.COPY_PROJECT_PERMISSIONS
});
exports.copyProjectPermissions = copyProjectPermissions;
const copyProjectPermissionsSuccess = () => ({
    type: ActionTypes.COPY_PROJECT_PERMISSIONS_SUCCESS
});
exports.copyProjectPermissionsSuccess = copyProjectPermissionsSuccess;
const copyProjectPermissionsFailure = (error) => ({
    type: ActionTypes.COPY_PROJECT_PERMISSIONS_FAILURE,
    error
});
exports.copyProjectPermissionsFailure = copyProjectPermissionsFailure;
//# sourceMappingURL=projects.js.map